export class Constants {
    static readonly FileTypeDiploma = "FileType:Diploma";
    static readonly ConfirmationTemplateIdKey = "confirmation";
    static readonly loginTemplateIdKey = "login";
    static readonly UserStorageKey = "user";
    static readonly ToastrTitle = "DASP";
}

export default Constants;
